"use client";

import {Layout as BaseLayout } from "antd"
import React, { useEffect } from "react";

const Layout = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        if (process.env.NODE_ENV === "production") {
          console.log = () => {}; // Nonaktifkan console.log
          console.warn = () => {}; // Nonaktifkan console.warn (opsional)
          console.error = () => {}; // Nonaktifkan console.error (opsional)
          console.info = () => {}; // Nonaktifkan console.info (opsional)
        }
      }, [])
    return <BaseLayout>
        {children}
    </BaseLayout>
}

export default Layout
